'use client';

import { Skeleton } from '@/components/common/feedback/skeleton/skeleton';
import Button from '@/components/global/button';
import Card from '@/components/global/card';
import SquaredAvatar from '@/components/global/squared-avatar';
import Typography from '@/components/global/typography';
import ROUTES from '@/lib/constants/routeConfig';
import { useI18n } from '@/locales/client';
import { Edit } from 'lucide-react';
import { useSession } from 'next-auth/react';
import Link from 'next/link';

export const UserProfile = () => {
  const t = useI18n();
  const { data: session } = useSession();

  if (!session)
    return (
      <Card variant='secondary'>
        <div className='flex items-center justify-between gap-2'>
          <div className='flex min-w-0 flex-1 items-center gap-2'>
            <Skeleton className='h-10 w-10 rounded-md' />
            <div className='flex min-w-0 flex-col gap-1'>
              <Skeleton className='h-4 w-28' />
              <Skeleton className='h-3 w-16' />
            </div>
          </div>
          <Skeleton className='h-8 w-8 rounded-md' />
        </div>
      </Card>
    );

  const isLawyer = session.user.role === 'lawyer';

  return (
    <Card variant='secondary'>
      <div className='flex items-center justify-between gap-2'>
        <div className='flex min-w-0 flex-1 items-center gap-2'>
          <SquaredAvatar
            image={session.user.picture || undefined}
            name={session.user.name || ''}
          />
          <div className='flex min-w-0 flex-col gap-1'>
            <Typography
              size='p'
              weight='bold'
              color='primary'
              className='w-full truncate'
            >
              {session.user.name}
            </Typography>
            <Typography size='span' weight='normal' color='secondary'>
              {session.user.role === 'lawyer'
                ? t('userProfile.lawyer')
                : t('userProfile.user')}
            </Typography>
          </div>
        </div>

        <Link
          href={
            isLawyer ? ROUTES.DASHBOARD.PROFILE : ROUTES.MARKETPLACE.PROFILE
          }
        >
          <Button variant='ghost' size='icon'>
            <Edit className='h-5 w-5' />
          </Button>
        </Link>
      </div>
    </Card>
  );
};
